<!--<sc-mat-table2-filter-->
<!--  *ngIf="withFilter"-->
<!--  [filters]="filters"-->
<!--  [filterValue]="dataSource.filter"-->
<!--  (filterEvent)="filter($event)">-->
<!--</sc-mat-table2-filter>-->
<mat-paginator [ngStyle]="{'display' : withPaginator ? 'block' : 'none' }"
               [pageSizeOptions]="pageSizeOptions"
               [pageSize]="pageSize"
               showFirstLastButtons></mat-paginator>

<div *ngIf="form" style="display:inline-block; width: 100%">
  <button mat-icon-button mat-button class="table-icon"
          *ngIf="tableActionButtons.displayAddButton"
          (click)="onAddClick()"
          matTooltip="{{'UTIL.BUTTONS.ADD' | translate}}"
          matTooltipPosition="above">
    <mat-icon>add</mat-icon>
  </button>
  <button mat-icon-button mat-button class="table-icon"
          *ngIf="tableActionButtons.displayEditButton"
          (click)="onEditClick()"
          matTooltip="{{'UTIL.BUTTONS.UPDATE' | translate}}"
          matTooltipPosition="above">
    <mat-icon>edit</mat-icon>
  </button>
  <button mat-icon-button mat-button class="table-icon"
          *ngIf="tableActionButtons.displayDuplicateButton"
          (click)="onDuplicateClick()"
          matTooltip="Dupliquer"
          matTooltipPosition="above">
    <mat-icon>content_copy</mat-icon>
  </button>
  <button mat-icon-button mat-button class="table-icon"
          *ngIf="tableActionButtons.displaySearchButton"
          (click)="onSearchClick()"
          matTooltip="Rechercher"
          matTooltipPosition="above">
    <mat-icon>search</mat-icon>
  </button>
  <button mat-icon-button mat-button class="table-icon"
          *ngIf="tableActionButtons.displayCalculateButton"
          (click)="onCalculateClick()"
          matTooltip="{{'UTIL.BUTTONS.DISTRIBUTE' | translate}}"
          matTooltipPosition="above">
    <mat-icon>euro_symbol</mat-icon>
  </button>
  <button mat-icon-button mat-button class="table-icon"
          *ngIf="tableActionButtons.displayImportButton"
          (click)="onImportClick()"
          matTooltip="{{'UTIL.BUTTONS.IMPORT' | translate}}"
          matTooltipPosition="above">
    <mat-icon>save_alt</mat-icon>
  </button>
  <button mat-icon-button mat-button class="table-icon"
          *ngIf="tableActionButtons.displayProtectButton"
          (click)="onProtectClick()"
          matTooltip="{{'UTIL.BUTTONS.PROTECT' | translate}}"
          matTooltipPosition="above">
    <mat-icon>verified_user</mat-icon>
  </button>
  <button mat-icon-button mat-button id="removeItem" class="table-icon"
          *ngIf="tableActionButtons.displayDeleteButton"
          (click)="removeItem()"
          matTooltip="{{'UTIL.BUTTONS.DELETE' | translate}}"
          matTooltipPosition="above">
    <mat-icon>delete</mat-icon>
  </button>
  <mat-slide-toggle class="slide-toggle"
    *ngIf="tableActionButtons.displaySlideToggle"
    [checked]="slideToggleEnabled"
    labelPosition="before"
    (change)="handleSwitch($event)">
    <span *ngIf="slideToggleEnabled"> {{ 'UTIL.BUTTONS.SLIDE_TOGGLE_ON' | translate}} </span>
    <span *ngIf="!slideToggleEnabled"> {{ 'UTIL.BUTTONS.SLIDE_TOGGLE_OFF' | translate}} </span>
  </mat-slide-toggle>
</div>
<div [hidden]="!showProgressBar">
  <sc-progress-bar></sc-progress-bar>
</div>
<div [hidden]="showProgressBar" class="mat-elevation-z8" [formGroup]="formGroup">
  <mat-table matSort [dataSource]="dataSource" [ngClass]="{'mat-row-hover':hoverRow}" [ngStyle]="{  'overflow': 'auto',
  'max-height': maxHeight}">

    <div *ngFor="let column of columnNames; let i=index">

      <ng-container matColumnDef="{{column}}">

        <!-- CheckBox Column -->
        <div *ngIf="column === 'checkBoxColumn'; else elseBlock">
          <mat-header-cell *matHeaderCellDef [ngStyle]="{'flex-grow':checkboxFlexGrow, 'justify-content': 'center'}"
                           class="checkBox">
            <mat-checkbox
              (change)="selectAllItem()"
              [(ngModel)]="selectAllItems"
              [ngModelOptions]="{standalone: true}">
            </mat-checkbox>
          </mat-header-cell>
          <mat-cell *matCellDef="let item; let j=index" class="checkBox"
                    [ngStyle]="{'flex-grow': checkboxFlexGrow, 'justify-content': 'center'}"
                    (click)="$event.stopPropagation()">
            <mat-checkbox (change)="selectOrUnselectItem(item)"
                          [(ngModel)]="item.checked"
                          [ngModelOptions]="{standalone: true}">
            </mat-checkbox>
          </mat-cell>
        </div>
        <ng-template #elseBlock>
          <!--If form deactivate sorting-->
          <div *ngIf="showTooltipOnColumn">
            <mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="{{translatedColumnNames[i] | translate}}"
                             matTooltipPosition="above"
                             [ngStyle]="{'flex-grow': columnsDetails[i].columnFlexGrow,'justify-content': columnsDetails[i].withFilter ? 'left': 'center'}">
              <label *ngIf="!columnsDetails[i].withFilter"> {{translatedColumnNames[i] | translate}}</label>
              <mat-form-field *ngIf="columnsDetails[i].withFilter" style=" width:100%">
                <input [(ngModel)]="columnsDetails[i].filterValue" [ngModelOptions]="{standalone: true}"
                       (click)="$event.stopPropagation()" matInput
                       placeholder="{{translatedColumnNames[i] | translate}}"
                       (change)="filter($event, columnsDetails[i].field)">
              </mat-form-field>
            </mat-header-cell>
          </div>

          <div *ngIf="!showTooltipOnColumn">
            <mat-header-cell *matHeaderCellDef mat-sort-header
                             [ngStyle]="{'flex-grow': columnsDetails[i].columnFlexGrow,'justify-content': columnsDetails[i].withFilter ? 'left': 'center'}">
              <label *ngIf="!columnsDetails[i].withFilter"> {{translatedColumnNames[i] | translate}}</label>
              <mat-form-field *ngIf="columnsDetails[i].withFilter" style=" width:100%">
                <input [(ngModel)]="columnsDetails[i].filterValue" [ngModelOptions]="{standalone: true}"
                       (click)="$event.stopPropagation()" matInput
                       placeholder="{{translatedColumnNames[i] | translate}}"
                       (change)="filter($event, columnsDetails[i].field)">
              </mat-form-field>
            </mat-header-cell>
          </div>

          <div [ngSwitch]="columnsDetails[i].inputType">
            <!-- LABEL TYPE -->
            <div *ngSwitchCase="1">
              <!-- Default label type-->
              <div
                *ngIf="!columnsDetails[i].currencyType && !columnsDetails[i].iconType && !columnsDetails[i].dateFormat &&
                  !columnsDetails[i].dateFormatLegal">
                <mat-cell *matCellDef="let item" [ngStyle]="{'flex-grow': columnsDetails[i].columnFlexGrow}"
                          [ngClass]="{'text-align-left':columnsDetails[i].textAlign === 1, 'text-align-center':columnsDetails[i].textAlign === 2, 'text-align-right':columnsDetails[i].textAlign === 3}">
                  <span style="width: 95%">{{item[column].matTableValue}}</span>
                </mat-cell>
              </div>
              <!-- Currency Type -->
              <div *ngIf="columnsDetails[i].currencyType">
                <mat-cell *matCellDef="let item"
                          [ngStyle]="{'flex-grow': columnsDetails[i].columnFlexGrow,'justify-content':'right'}">
                  <span
                    style="width: 95%;text-align: right">{{item[column].matTableValue | currency:item.currencyCode ? item.currencyCode : ' ' : 'symbol' : '1.2-3' }}</span>
                </mat-cell>
              </div>
              <!-- Icon Type-->
              <div *ngIf="columnsDetails[i].iconType">
                <mat-cell *matCellDef="let item" [ngStyle]="{'flex-grow': columnsDetails[i].columnFlexGrow}">
                  <div [ngSwitch]="columnsDetails[i].iconTemplate" class="icon">


                    <div *ngSwitchCase="1">
                      <sc-video-purchase-order-type-icon-component
                        [type]="item.type">
                      </sc-video-purchase-order-type-icon-component>
                    </div>

                    <div *ngSwitchCase="2">
                      <sc-video-status-icon-component
                        [status]="item.status.id"
                        [tooltip]="item.status.label">
                      </sc-video-status-icon-component>
                    </div>

                    <div *ngSwitchCase="3">
                      <sc-expenditure-status-icon-component
                        [status]="item.status.id"
                        [tooltip]="item.status.label">
                      </sc-expenditure-status-icon-component>
                    </div>

                  </div>
                </mat-cell>
              </div>

              <div *ngIf="columnsDetails[i].dateFormatLegal">
                <mat-cell *matCellDef="let item" [ngStyle]="{'flex-grow': columnsDetails[i].columnFlexGrow}"
                          [ngClass]="{'text-align-left':columnsDetails[i].textAlign === 1, 'text-align-center':columnsDetails[i].textAlign === 2,
                          'text-align-right':columnsDetails[i].textAlign === 3}">
                  {{item[column].matTableValue | myLocalDateFormat:
                  translateService.currentLang:columnsDetails[i].dateFormatLegal}}
                </mat-cell>
              </div>

              <div *ngIf="columnsDetails[i].dateFormat">
                <mat-cell *matCellDef="let item" [ngStyle]="{'flex-grow': columnsDetails[i].columnFlexGrow}"
                          [ngClass]="{'text-align-left':columnsDetails[i].textAlign === 1, 'text-align-center':columnsDetails[i].textAlign === 2,
                          'text-align-right':columnsDetails[i].textAlign === 3}">
                  {{item[column].matTableValue | date: columnsDetails[i].dateFormat}}
                </mat-cell>
              </div>
            </div>
            <!-- INPUT_TEXT-->
            <div *ngSwitchCase="2">
              <mat-cell *matCellDef="let item; let j=index" [ngStyle]="{'flex-grow': columnsDetails[i].columnFlexGrow}"
                        (click)="$event.stopPropagation()"
                        [ngClass]="{'text-align-left':columnsDetails[i].textAlign === 1, 'text-align-center':columnsDetails[i].textAlign === 2, 'text-align-right':columnsDetails[i].textAlign === 3}">
                <mat-form-field style="width: 95%">
                  <div [ngSwitch]="columnsDetails[i].fieldType">
                    <input *ngSwitchDefault
                           matInput
                           [(ngModel)]="item[columnsDetails[i].field]"
                           formControlName="{{prefix + '-' + columnsDetails[i].field + item.uuid}}">
                    <mat-hint align="end" *ngIf="columnsDetails[i].maxLength">{{item[columnsDetails[i].field].length}}
                      / {{columnsDetails[i].maxLength}}
                    </mat-hint>
                    <input *ngSwitchCase="2"
                           matInput
                           [(ngModel)]="item[columnsDetails[i].field][columnsDetails[i].subField]"
                           formControlName="{{prefix + '-' + columnNames[i] + item.uuid}}">
                    <mat-hint align="end"
                              *ngIf="columnsDetails[i].maxLength">
                      {{item[columnsDetails[i].field][columnsDetails[i].subField].length}}
                      / {{columnsDetails[i].maxLength}}
                    </mat-hint>
                    <input *ngSwitchCase="3"
                           matInput
                           [(ngModel)]="item[columnsDetails[i].field][columnsDetails[i].subField][columnsDetails[i].subSubField]"
                           formControlName="{{prefix + '-' + columnNames[i] + item.uuid}}">
                    <mat-hint align="end"
                              *ngIf="columnsDetails[i].maxLength">
                      {{item[columnsDetails[i].field][columnsDetails[i].subField][columnsDetails[i].subSubField].length}}
                      / {{columnsDetails[i].maxLength}}
                    </mat-hint>
                  </div>
                  <mat-hint align="start" *ngIf="columnsDetails[i].pattern">{{columnsDetails[i].pattern}}</mat-hint>
                </mat-form-field>
              </mat-cell>
            </div>
            <!-- INPUT_NUMBER-->
            <div *ngSwitchCase="3">
              <mat-cell *matCellDef="let item" [ngStyle]="{'flex-grow': columnsDetails[i].columnFlexGrow}"
                        (click)="$event.stopPropagation()"
                        style="justify-content: center">
                <mat-form-field style="width: 95%"
                                [ngClass]="{'text-align-left':columnsDetails[i].textAlign === 1, 'text-align-center':columnsDetails[i].textAlign === 2, 'text-align-right':columnsDetails[i].textAlign === 3}">
                  <div [ngSwitch]="columnsDetails[i].fieldType">
                    <input *ngSwitchDefault
                           matInput
                           type="text"
                           myNumberFormatter
                           pattern="[0-9 .]+"
                           decimalNumber="{{columnsDetails[i].decimalNumber}}"
                           [(ngModel)]="item[columnsDetails[i].field]"
                           formControlName="{{prefix + '-' + columnsDetails[i].field + item.uuid}}"
                           (change)="onUpdateValue($event, item.uuid, columnsDetails[i])">
                    <input *ngSwitchCase="2"
                           matInput
                           type="text"
                           myNumberFormatter
                           pattern="[0-9 .]+"
                           decimalNumber="{{columnsDetails[i].decimalNumber}}"
                           [(ngModel)]="item[columnsDetails[i].field][columnsDetails[i].subField]"
                           formControlName="{{prefix + '-' + columnNames[i] + item.uuid}}"
                           (change)="onUpdateValue($event, item.uuid, columnsDetails[i])">
                    <input *ngSwitchCase="3"
                           matInput
                           type="text"
                           myNumberFormatter
                           pattern="[0-9 .]+"
                           decimalNumber="{{columnsDetails[i].decimalNumber}}"
                           [(ngModel)]="item[columnsDetails[i].field][columnsDetails[i].subField][columnsDetails[i].subSubField]"
                           formControlName="{{prefix + '-' + columnNames[i] + item.uuid}}"
                           (change)="onUpdateValue($event, item.uuid, columnsDetails[i])">
                  </div>
                </mat-form-field>
              </mat-cell>
            </div>
            <!-- AUTOCOMPLETE -->
            <div *ngSwitchCase="4">
              <mat-cell *matCellDef="let item; let j=index" [ngStyle]="{'flex-grow': columnsDetails[i].columnFlexGrow}"
                        (click)="$event.stopPropagation()"
                        style="justify-content: center">

                <div [ngSwitch]="columnsDetails[i].fieldType" style="width: 95%">

                  <sc-auto-complete-component *ngSwitchDefault
                                              style="width: 100%"
                                              [control]="formGroup.get(prefix + '-' + columnsDetails[i].field + item.uuid)"
                                              [fieldToDisplay]="columnsDetails[i].fieldToDisplay"
                                              [suggestions]="columnsDetails[i].suggestions"
                                              [model]="item[columnsDetails[i].field]"
                                              [appearance]="''"
                                              [debounceDelay]="500"
                                              [ordered]="ordered"
                                              (autoCompleteBlurEmitter)="changesEmit($event, columnsDetails[i].field, item.uuid)"
                                              (autoCompleteGenericEmitter)="search($event, columnsDetails[i].field, item.uuid)"
                                              (autoCompleteClickEmitter)="autoCompleteClick($event, columnsDetails[i].field, item.uuid)"
                                              (autoCompleteOnSelectGenericEmitter)="onSelect($event, item.uuid, columnsDetails[i].field, i)">
                  </sc-auto-complete-component>
                  <sc-auto-complete-component *ngSwitchCase="2"
                                              style="width: 100%"
                                              [control]="formGroup.get(prefix + '-' + columnNames[i] + item.uuid)"
                                              [fieldToDisplay]="columnsDetails[i].fieldToDisplay"
                                              [suggestions]="columnsDetails[i].suggestions"
                                              [appearance]="''"
                                              [model]="item[columnsDetails[i].field][columnsDetails[i].subField]"
                                              [debounceDelay]="500"
                                              [ordered]="ordered"
                                              (autoCompleteBlurEmitter)="changesEmit($event, columnsDetails[i].field, item.uuid)"
                                              (autoCompleteGenericEmitter)="search($event, columnsDetails[i].subField, item.uuid)"
                                              (autoCompleteClickEmitter)="autoCompleteClick($event, columnsDetails[i].field, item.uuid)"
                                              (autoCompleteOnSelectGenericEmitter)="onSelect($event, item.uuid, columnsDetails[i].subField, i)">
                  </sc-auto-complete-component>

                  <sc-auto-complete-component *ngSwitchCase="3"
                                              style="width: 100%"
                                              [control]="formGroup.get(prefix + '-' + columnNames[i] + item.uuid)"
                                              [fieldToDisplay]="columnsDetails[i].fieldToDisplay"
                                              [appearance]="''"
                                              [suggestions]="columnsDetails[i].suggestions"
                                              [model]="item[columnsDetails[i].field][columnsDetails[i].subField][columnsDetails[i].subSubField]"
                                              [debounceDelay]="500"
                                              [ordered]="ordered"
                                              (autoCompleteBlurEmitter)="changesEmit($event, columnsDetails[i].field, item.uuid)"
                                              (autoCompleteGenericEmitter)="search($event, columnsDetails[i].subSubField, item.uuid)"
                                              (autoCompleteOnSelectGenericEmitter)="onSelect($event, item.uuid, columnsDetails[i].subSubField, i)">
                  </sc-auto-complete-component>
                </div>

              </mat-cell>
            </div>

            <!-- SELECT -->
            <div *ngSwitchCase="5">
              <mat-cell *matCellDef="let item; let j=index" style="justify-content: center"
                        (click)="$event.stopPropagation()"
                        [ngStyle]="{'flex-grow': columnsDetails[i].columnFlexGrow}">

                <mat-form-field [ngSwitch]="columnsDetails[i].fieldType" style="width: 95%">

                  <mat-select *ngSwitchDefault
                              [(ngModel)]="item[columnsDetails[i].field]"
                              formControlName="{{prefix + '-' + columnNames[i] + item.uuid}}"
                              [compareWith]="compareWith"
                              (valueChange)="onSelectOption($event, columnsDetails[i].field, item.uuid)">
                    <mat-option *ngFor="let value of columnsDetails[i].selectValues" [value]="value">
                      {{value[columnsDetails[i].fieldToDisplay]}}
                    </mat-option>
                  </mat-select>

                  <mat-select *ngSwitchCase="2"
                              [(ngModel)]="item[columnsDetails[i].field]"
                              formControlName="{{prefix + '-' + columnsDetails[i].field + item.uuid}}"
                              (valueChange)="onSelectOption($event, columnNames[i], item.uuid)">
                    <mat-option *ngFor="let value of columnsDetails[i].selectValues" [value]="value">
                      {{value[columnsDetails[i].fieldToDisplay]}}
                    </mat-option>
                  </mat-select>

                  <mat-select *ngSwitchCase="3"
                              [(ngModel)]="item[columnsDetails[i].field][columnsDetails[i].subField]"
                              formControlName="{{prefix + '-' + columnNames[i] + item.uuid}}"
                              (valueChange)="onSelectOption($event, columnNames[i], item.uuid)">
                    <mat-option *ngFor="let value of columnsDetails[i].selectValues" [value]="value">
                      {{value[columnsDetails[i].fieldToDisplay]}}
                    </mat-option>
                  </mat-select>

                </mat-form-field>
              </mat-cell>
            </div>

            <!-- SIMPLE_AUTOCOMPLETE -->
            <div *ngSwitchCase="6">
              <mat-cell *matCellDef="let item; let j=index"
                        (click)="$event.stopPropagation()"
                        [ngStyle]="{'flex-grow': columnsDetails[i].columnFlexGrow}">
                <mat-form-field style="width: 100%">
                  <input matInput [matAutocomplete]="auto" [(ngModel)]="item[columnsDetails[i].field]"
                         (focus)="getListForSimpleAuto($event, item.uuid, columnsDetails[i])"
                         formControlName="{{prefix + '-' + columnsDetails[i].field + item.uuid}}">
                  <mat-autocomplete #auto="matAutocomplete">
                    <mat-option *ngFor="let value of columnsDetails[i].filteredList | async"
                                [value]="value[columnsDetails[i].fieldToDisplay]">
                      {{value[columnsDetails[i].fieldToDisplay]}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </mat-cell>
            </div>

            <!-- LABEL_NUMBER-->
            <div *ngSwitchCase="7">
              <mat-cell *matCellDef="let item"
                        [ngStyle]="{'flex-grow': columnsDetails[i].columnFlexGrow}"
                        [ngClass]="{'text-align-left':columnsDetails[i].textAlign === 1, 'text-align-center':columnsDetails[i].textAlign === 2, 'text-align-right':columnsDetails[i].textAlign === 3}">
                <span
                  style="width: 100%;text-align: right">{{item[column].matTableValue | myNumberFormat:columnsDetails[i].decimalNumber }}</span>
              </mat-cell>
            </div>

            <!-- CHECK_BOX_FORM -->
            <div *ngSwitchCase="8">
              <mat-cell *matCellDef="let item"
                        (click)="$event.stopPropagation()"
                        [ngStyle]="{'flex-grow': columnsDetails[i].columnFlexGrow,'justify-content':'center'}">
                <div [ngSwitch]="columnsDetails[i].fieldType">
                  <mat-checkbox *ngSwitchDefault [(ngModel)]="item[columnsDetails[i].field]"
                                (change)="onCheckedColumn(item)" [ngModelOptions]="{standalone: true}"></mat-checkbox>
                  <mat-checkbox *ngSwitchCase="2"
                                [(ngModel)]="item[columnsDetails[i].field][columnsDetails[i].subField]"
                                (change)="onCheckedColumn(item)" [ngModelOptions]="{standalone: true}"></mat-checkbox>
                  <mat-checkbox *ngSwitchCase="3"
                                [(ngModel)]="item[columnsDetails[i].field][columnsDetails[i].subField][columnsDetails[i].subSubField]"
                                (change)="onCheckedColumn(item)" [ngModelOptions]="{standalone: true}"></mat-checkbox>
                  <mat-checkbox *ngSwitchCase="4"
                                [(ngModel)]="item[columnsDetails[i].field][columnsDetails[i].subField][columnsDetails[i].subSubField][columnsDetails[i].subSubSubField]"
                                (change)="onCheckedColumn(item)" [ngModelOptions]="{standalone: true}"></mat-checkbox>
                </div>
              </mat-cell>
            </div>
            <div *ngSwitchCase="9">
              <mat-cell *matCellDef="let item; let j=index" [ngStyle]="{'flex-grow': columnsDetails[i].columnFlexGrow}"
                        (click)="$event.stopPropagation()"
                        style="justify-content: center">
                <mat-form-field style="width: 95%">
                  <input matInput [matDatepicker]="picker"
                         [(ngModel)]="item[columnsDetails[i].field]"
                         formControlName="{{prefix + '-' + columnsDetails[i].field + item.uuid}}">
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </mat-cell>
            </div>
            <!-- CHECK_BOX_CONSULT -->
            <div *ngSwitchCase="10">
              <mat-cell *matCellDef="let item"
                        [ngStyle]="{'flex-grow': columnsDetails[i].columnFlexGrow,'justify-content':'center'}">
                <div [ngSwitch]="columnsDetails[i].fieldType">
                  <div *ngSwitchDefault>
                    <mat-icon *ngIf="item[columnsDetails[i].field]  && !enableRedCheckboxColumn" fxFlex="25%">check</mat-icon>
                    <mat-icon *ngIf="item[columnsDetails[i].field] && enableRedCheckboxColumn" fxFlex="25%" style="color: red">check</mat-icon>
                    <mat-icon *ngIf="!item[columnsDetails[i].field] && enableRedClearIconOnCheckBox" style="color:red"
                              fxFlex="25%">clear
                    </mat-icon>
                  </div>
                  <div *ngSwitchCase="2">
                    <mat-icon *ngIf="item[columnsDetails[i].field][columnsDetails[i].subField] && !enableRedCheckboxColumn" style="color:#2ecc71"
                              fxFlex="25%">check
                    </mat-icon>
                    <mat-icon *ngIf="item[columnsDetails[i].field][columnsDetails[i].subField] && enableRedCheckboxColumn" style="color:red"
                              fxFlex="25%">check
                    </mat-icon>
                    <mat-icon *ngIf="!item[columnsDetails[i].field][columnsDetails[i].subField]" style="color:red"
                              fxFlex="25%">clear
                    </mat-icon>
                  </div>
                  <div *ngSwitchCase="3">
                    <mat-icon
                      *ngIf="item[columnsDetails[i].field][columnsDetails[i].subField][columnsDetails[i].subSubField] && !enableRedCheckboxColumn"
                      style="color:#2ecc71" fxFlex="25%">check
                    </mat-icon>
                    <mat-icon
                      *ngIf="item[columnsDetails[i].field][columnsDetails[i].subField][columnsDetails[i].subSubField] && enableRedCheckboxColumn"
                      style="color:red" fxFlex="25%">check
                    </mat-icon>
                    <mat-icon
                      *ngIf="!item[columnsDetails[i].field][columnsDetails[i].subField][columnsDetails[i].subSubField]"
                      style="color:red" fxFlex="25%">clear
                    </mat-icon>
                  </div>
                  <div *ngSwitchCase="4">
                    <mat-icon
                      *ngIf="item[columnsDetails[i].field][columnsDetails[i].subField][columnsDetails[i].subSubField][columnsDetails[i].subSubSubField]
                        && !enableRedCheckboxColumn"
                      style="color:#2ecc71" fxFlex="25%">check
                    </mat-icon>
                    <mat-icon
                      *ngIf="item[columnsDetails[i].field][columnsDetails[i].subField][columnsDetails[i].subSubField][columnsDetails[i].subSubSubField]
                        && enableRedCheckboxColumn"
                      style="color:red" fxFlex="25%">check
                    </mat-icon>
                    <mat-icon
                      *ngIf="!item[columnsDetails[i].field][columnsDetails[i].subField][columnsDetails[i].subSubField][columnsDetails[i].subSubSubField]"
                      style="color:red" fxFlex="25%">clear
                    </mat-icon>
                  </div>
                </div>
              </mat-cell>
            </div>

            <!-- SELECT_EVENT -->
            <div *ngSwitchCase="11">
              <mat-cell *matCellDef="let item" style="justify-content: center"
                        (click)="$event.stopPropagation()"
                        [ngStyle]="{'flex-grow': columnsDetails[i].columnFlexGrow}">

                <mat-form-field [ngSwitch]="columnsDetails[i].fieldType" style="width: 95%">

                  <mat-select *ngSwitchDefault
                              [(ngModel)]="item[columnsDetails[i].field]"
                              formControlName="{{prefix + '-' + columnNames[i] + item.uuid}}"
                              (valueChange)="onSelectOption($event, columnsDetails[i].field,  item.uuid)">
                    <mat-option *ngFor="let value of columnsDetails[i].listOfListOfSelectValues[item.uuid]"
                                [value]="value">
                      {{value[columnsDetails[i].fieldToDisplay]}}
                    </mat-option>
                  </mat-select>

                  <mat-select *ngSwitchCase="2"
                              [(ngModel)]="item[columnsDetails[i].field]"
                              formControlName="{{prefix + '-' + columnsDetails[i].field + item.uuid}}"
                              (valueChange)="onSelectOption($event, columnNames[i], item.uuid)">
                    <mat-option *ngFor="let value of columnsDetails[i].listOfListOfSelectValues[item.uuid]"
                                [value]="value">
                      {{value[columnsDetails[i].fieldToDisplay]}}
                    </mat-option>
                  </mat-select>

                  <mat-select *ngSwitchCase="3"
                              [(ngModel)]="item[columnsDetails[i].field][columnsDetails[i].subField]"
                              formControlName="{{prefix + '-' + columnNames[i] + item.uuid}}"
                              (valueChange)="onSelectOption($event, columnNames[i], item.uuid)">
                    <mat-option *ngFor="let value of columnsDetails[i].listOfListOfSelectValues[item.uuid]"
                                [value]="value">
                      {{value[columnsDetails[i].fieldToDisplay]}}
                    </mat-option>
                  </mat-select>

                </mat-form-field>
              </mat-cell>
            </div>

            <!-- SELECT ID -->
            <div *ngSwitchCase="12">
              <mat-cell *matCellDef="let item; let j=index" style="justify-content: center"
                        (click)="$event.stopPropagation()"
                        [ngStyle]="{'flex-grow': columnsDetails[i].columnFlexGrow}">

                <mat-form-field [ngSwitch]="columnsDetails[i].fieldType" style="width: 95%">

                  <mat-select *ngSwitchDefault
                              [(ngModel)]="item[columnsDetails[i].field]"
                              formControlName="{{prefix + '-' + columnNames[i] + item.uuid}}"
                              (valueChange)="onSelectOption($event, columnsDetails[i].field, item.uuid)">
                    <mat-option *ngFor="let value of columnsDetails[i].selectValues" [value]="value.id">
                      {{value[columnsDetails[i].fieldToDisplay]}}
                    </mat-option>
                  </mat-select>

                  <mat-select *ngSwitchCase="2"
                              [(ngModel)]="item[columnsDetails[i].field]"
                              formControlName="{{prefix + '-' + columnsDetails[i].field + item.uuid}}"
                              (valueChange)="onSelectOption($event, columnNames[i], item.uuid)">
                    <mat-option *ngFor="let value of columnsDetails[i].selectValues" [value]="value.id">
                      {{value[columnsDetails[i].fieldToDisplay]}}
                    </mat-option>
                  </mat-select>

                  <mat-select *ngSwitchCase="3"
                              [(ngModel)]="item[columnsDetails[i].field][columnsDetails[i].subField]"
                              formControlName="{{prefix + '-' + columnNames[i] + item.uuid}}"
                              (valueChange)="onSelectOption($event, columnNames[i], item.uuid)">
                    <mat-option *ngFor="let value of columnsDetails[i].selectValues" [value]="value.id">
                      {{value[columnsDetails[i].fieldToDisplay]}}
                    </mat-option>
                  </mat-select>

                </mat-form-field>
              </mat-cell>
            </div>

            <!-- CUSTOM -->
            <div *ngSwitchCase="13">
              <mat-cell *matCellDef="let item; let j=index"
                        [ngStyle]="{'flex-grow': columnsDetails[i].columnFlexGrow}"
                        [ngClass]="{'justify-content-center':columnsDetails[i].justifyContentCenter,
                        'justify-content-left':!columnsDetails[i].justifyContentCenter}">
                <sc-custom-table-cell-content
                  [htmlTemplate]="item[columnsDetails[i].field]"></sc-custom-table-cell-content>
              </mat-cell>
            </div>

            <!-- INPUT_TEXTAREA-->
            <!-- Have duplicated the same stuff as Input -->
            <div *ngSwitchCase="14">
              <mat-cell *matCellDef="let item; let j=index" [ngStyle]="{'flex-grow': columnsDetails[i].columnFlexGrow}"
                        (click)="$event.stopPropagation()"
                        [ngClass]="{'text-align-left':columnsDetails[i].textAlign === 1, 'text-align-center':columnsDetails[i].textAlign === 2, 'text-align-right':columnsDetails[i].textAlign === 3}">
                <mat-form-field style="width: 95%">
                  <div [ngSwitch]="columnsDetails[i].fieldType">
                    <textarea *ngSwitchDefault
                              matInput
                              [(ngModel)]="item[columnsDetails[i].field]"
                              formControlName="{{prefix + '-' + columnsDetails[i].field + item.uuid}}"></textarea>
                    <mat-hint align="end" *ngIf="columnsDetails[i].maxLength">{{item[columnsDetails[i].field].length}}
                      / {{columnsDetails[i].maxLength}}
                    </mat-hint>
                    <textarea *ngSwitchCase="2"
                              matInput
                              [(ngModel)]="item[columnsDetails[i].field][columnsDetails[i].subField]"
                              formControlName="{{prefix + '-' + columnNames[i] + item.uuid}}"></textarea>
                    <mat-hint align="end"
                              *ngIf="columnsDetails[i].maxLength">
                      {{item[columnsDetails[i].field][columnsDetails[i].subField].length}}
                      / {{columnsDetails[i].maxLength}}
                    </mat-hint>
                    <textarea *ngSwitchCase="3"
                              matInput
                              [(ngModel)]="item[columnsDetails[i].field][columnsDetails[i].subField][columnsDetails[i].subSubField]"
                              formControlName="{{prefix + '-' + columnNames[i] + item.uuid}}"></textarea>
                    <mat-hint align="end"
                              *ngIf="columnsDetails[i].maxLength">
                      {{item[columnsDetails[i].field][columnsDetails[i].subField][columnsDetails[i].subSubField].length}}
                      / {{columnsDetails[i].maxLength}}
                    </mat-hint>
                  </div>
                  <mat-hint align="start" *ngIf="columnsDetails[i].pattern">{{columnsDetails[i].pattern}}</mat-hint>
                </mat-form-field>
              </mat-cell>
            </div>


            <!-- MAT_CHIP_LIST + AUTO_COMPLETE COMBINED ON RIGHTS-->
            <div *ngSwitchCase="15">
              <mat-cell *matCellDef="let item" style="justify-content: center"
                        [ngStyle]="{'flex-grow': columnsDetails[i].columnFlexGrow}">
                <div style="width: 95%">
                  <mat-chip-list>
                    <mat-chip *ngFor="let q of item[columnsDetails[i].field]"
                              [selectable]="true"
                              color="accent"
                              autofocus="true"
                              class="sc-chip"
                              [removable]="true"
                              (removed)="remove(q, item[columnsDetails[i].field])"
                              style="width:39%">
                      {{q.beneficiaryQualityRef.label}}
                      <mat-icon matChipRemove (click)="delete(q, item.uuid)">clear</mat-icon>
                    </mat-chip>
                  </mat-chip-list>
                  <sc-auto-complete-component style="width: 100%"
                                              [control]="formGroup.get(prefix + '-' + columnsDetails[i].field + item.uuid)"
                                              [fieldToDisplay]="columnsDetails[i].fieldToDisplay"
                                              [suggestions]="columnsDetails[i].suggestions"
                                              [appearance]="''"
                                              [debounceDelay]="500"
                                              (autoCompleteGenericEmitter)="search($event, columnsDetails[i].field, item.uuid)"
                                              (autoCompleteClickEmitter)="autoCompleteClick($event, columnsDetails[i].field, item.uuid)"
                                              (autoCompleteOnSelectGenericEmitter)="onSelect($event, item.uuid, columnsDetails[i].field, i)">
                  </sc-auto-complete-component>
                </div>
              </mat-cell>
            </div>

            <!-- SEARCH ICONS -->
            <div *ngSwitchCase="16">
              <mat-cell *matCellDef="let item"
                        [ngStyle]="{'flex-grow': columnsDetails[i].columnFlexGrow}">
                <span style="width: 95%">{{item[column].matTableValue}}</span>
                <i style="vertical-align: middle" class="material-icons"
                   (click)="onSearchRightHolderClick(item, $event)">
                  search
                </i>
              </mat-cell>
            </div>

            <!--  MAT-LIST ON RIGHTS-->
            <div *ngSwitchCase='17'>
              <mat-cell *matCellDef='let item' [ngStyle]="{'flex-grow': columnsDetails[i].columnFlexGrow}">
                <div [ngSwitch]="columnsDetails[i].fieldType">
                  <mat-list>
                    <mat-list-item class='mat-list-item-style' *ngFor='let value of item[columnsDetails[i].field]'>
                      <mat-icon class='mat-icons-lens'>lens</mat-icon>
                      <!-- MESSAGE CONTROLS LINK ON RIGHTS -->
                      <span *ngSwitchCase="1" [ngClass]="{'span-link span-link-active': applyStyleForMsgCtrl}"
                            (click)='onConsultMessageControlClick(value)'>
                        {{value[columnsDetails[i].fieldToDisplay]}}
                      </span>
                      <!-- TOOLTIP ON RIGHTS -->
                      <span *ngSwitchCase="2" matTooltip="{{value[columnsDetails[i].fieldToDisplayDetails]}}"
                            matTooltipClass="tooltip-linebreak">
                        {{value[columnsDetails[i].fieldToDisplay]}}
                      </span>
                    </mat-list-item>
                  </mat-list>
                </div>
              </mat-cell>
            </div>

          </div>

        </ng-template>
      </ng-container>

    </div>

    <mat-header-row *matHeaderRowDef="columnNames ;sticky: true"
                    [ngStyle]="{'height': withFilter ? '65px':'42px'}"></mat-header-row>
    <mat-row class="max-height-set" *matRowDef="let row; columns: columnNames;"
             (click)="onRowClick(row, $event)"
             (contextmenu)="sendContextMenu(row, $event)"
             [ngClass]="{'clickable' : clickableRow, 'mat-row-consistency': row.consistency
             && isInTableConsistency, 'mat-row-not-consistency': !row.consistency && isInTableConsistency}">
      <div style="height:50px; width: 100%"></div>
    </mat-row>


  </mat-table>
</div>
